import * as React from 'react'

const SvgAdminAccountingIcon = ({ stroke }) => (
  <svg
    width="22"
    height="21"
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3.40039C12 4.50496 9.53757 5.40039 6.5 5.40039C3.46243 5.40039 1 4.50496 1 3.40039M12 3.40039C12 2.29582 9.53757 1.40039 6.5 1.40039C3.46243 1.40039 1 2.29582 1 3.40039M12 3.40039V4.90039M1 3.40039V15.4004C1 16.505 3.46243 17.4004 6.5 17.4004M6.5 9.40039C6.33145 9.40039 6.16468 9.39763 6 9.39224C3.19675 9.30038 1 8.44367 1 7.40039M6.5 13.4004C3.46243 13.4004 1 12.505 1 11.4004M21 9.90039C21 11.005 18.5376 11.9004 15.5 11.9004C12.4624 11.9004 10 11.005 10 9.90039M21 9.90039C21 8.79582 18.5376 7.90039 15.5 7.90039C12.4624 7.90039 10 8.79582 10 9.90039M21 9.90039V17.4004C21 18.505 18.5376 19.4004 15.5 19.4004C12.4624 19.4004 10 18.505 10 17.4004V9.90039M21 13.6504C21 14.755 18.5376 15.6504 15.5 15.6504C12.4624 15.6504 10 14.755 10 13.6504"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgAdminAccountingIcon
